import { IEventEnrollment } from '../../../../../store/admin/eventEnrollments/store';

export const filter = (searchValue: string) => (enrollment: IEventEnrollment) => {
  const {
    user: { firstName, lastName, email }
  } = enrollment;

  return searchValue
    ? firstName.toUpperCase().includes(searchValue.toUpperCase()) ||
        lastName.toUpperCase().includes(searchValue.toUpperCase()) ||
        email.toUpperCase().includes(searchValue.toUpperCase())
    : true;
};
